import React from "react";
import styles from "./DropdownMenuDivider.module.css";

export const DropdownMenuDivider = (): JSX.Element => (
  <div role="separator" className={styles.divider} />
);
